<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
  <div class="block-content" [innerHTML]="blockContent"></div>
  <div class="content">
    <h4 class="header">{{contentHeader}}</h4>
    <div class="contentBody" [innerHTML]="content"></div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="rts-filled-button" alt="close" mat-dialog-close>Okay</button>
</mat-dialog-actions>
